global.initActivityLogs = () => import('./pages/activity_log').then(module => module.initActivityLogs());
global.initAdminConsultationsMap = (key, redMarkerImg, blueMarkerImg) => import('./map/consultation').then(module => module.initAdminConsultationsMap(key, redMarkerImg, blueMarkerImg));
